const local = {
    apiUrl: 'https://tomodoro-go-backend-hvblw.ondigitalocean.app/api/v1',
} as IConfig;

const dev = {
    apiUrl: 'https://api.dev.tomodoro.de/api/v1',
} as IConfig;

const stage = {
    apiUrl: 'https://api.stage.tomodoro.de/api/v1',
} as IConfig;

const production = {
    apiUrl: 'https://api.tomodoro.de/api/v1',
} as IConfig;

const config = () => {
    switch(process.env.REACT_APP_STAGE) {
        case "local":
            return local;
        case "stage":
            return stage;
        case "develop":
            return dev;
        default:
            return production;
    }
};

export interface IConfig  {
    apiUrl: string;
};

export default {
    ...config(),
} as IConfig;



// WEBPACK FOOTER //
// ./src/config.ts